import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { z } from 'zod/v4';
import { ResponseSchemaError } from '@/services/fetch/schemas/ResponseSchemaError';
export type ResponseSchemaErrorDebug = {
  error: unknown;
};
export function DevErrorRenderer(t0) {
  const $ = _c(31);
  const {
    error
  } = t0;
  if (process.env.NODE_ENV !== "development" || !error) {
    return null;
  }
  if (error instanceof ResponseSchemaError) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        px: 6
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== error) {
      t2 = z.prettifyError(error).split("\n").map(_temp);
      $[1] = error;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <Typography variant="h6" color="error">{t2}</Typography>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        mb: 1
      };
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== error.url) {
      t5 = <Typography variant="body2" sx={t4}>While fetching data from {error.url}</Typography>;
      $[6] = error.url;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography fontWeight={600}>More details</Typography></AccordionSummary>;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        fontSize: "0.875rem",
        whiteSpace: "pre-wrap",
        wordBreak: "break-all",
        m: 0
      };
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    let t8;
    if ($[10] !== error) {
      t8 = JSON.stringify(error, null, 2);
      $[10] = error;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    let t9;
    if ($[12] !== t8) {
      t9 = <Accordion>{t6}<AccordionDetails><Box component="pre" sx={t7}>{t8}</Box></AccordionDetails></Accordion>;
      $[12] = t8;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    let t10;
    if ($[14] !== t3 || $[15] !== t5 || $[16] !== t9) {
      t10 = <Box sx={t1}>{t3}{" "}{t5}{t9}</Box>;
      $[14] = t3;
      $[15] = t5;
      $[16] = t9;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    return t10;
  }
  let message;
  let stack;
  if (error instanceof Error) {
    message = error.message;
    stack = error.stack;
  } else {
    if (typeof error === "string") {
      message = error;
    } else {
      let t1;
      if ($[18] !== error) {
        t1 = JSON.stringify(error, null, 2);
        $[18] = error;
        $[19] = t1;
      } else {
        t1 = $[19];
      }
      message = t1;
    }
  }
  const t1 = message || "Unknown error";
  let t2;
  if ($[20] !== t1) {
    t2 = <Typography variant="h6" color="error">{t1}</Typography>;
    $[20] = t1;
    $[21] = t2;
  } else {
    t2 = $[21];
  }
  let t3;
  if ($[22] !== stack) {
    t3 = stack && <Accordion><AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography fontWeight={600}>Stack trace</Typography></AccordionSummary><AccordionDetails><Box component="pre" sx={{
          fontSize: "0.875rem",
          whiteSpace: "pre-wrap",
          wordBreak: "break-all",
          m: 0
        }}>{stack}</Box></AccordionDetails></Accordion>;
    $[22] = stack;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== error || $[25] !== stack) {
    t4 = !stack && typeof error === "object" && error && <Accordion><AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography fontWeight={600}>Details</Typography></AccordionSummary><AccordionDetails><Box component="pre" sx={{
          fontSize: "0.875rem",
          whiteSpace: "pre-wrap",
          wordBreak: "break-all",
          m: 0
        }}>{JSON.stringify(error, null, 2)}</Box></AccordionDetails></Accordion>;
    $[24] = error;
    $[25] = stack;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  let t5;
  if ($[27] !== t2 || $[28] !== t3 || $[29] !== t4) {
    t5 = <Box>{t2}{t3}{t4}</Box>;
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  return t5;
}
function _temp(line, index) {
  return <React.Fragment key={index}>{line}<br /></React.Fragment>;
}